import React from "react";

import styled from "styled-components";
import PropTypes from "prop-types";

import breakpoints from "../../../styles/breakpoints";

import { Container } from "../../atoms/Container";

const TabContainer = styled(Container)`
  height: 40px;
  display: flex;

  ${breakpoints.xsDown} {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
  }

  a:hover::after {
    transform: scaleX(1);
  }

  &:hover > a {
    border-bottom: transparent solid 2px;
  }

  a:hover ~ a {
    border-bottom: transparent solid 2px;
  }
`;

function TabBar({ backgroundColor, children }) {
  return (
    <div style={{ backgroundColor }}>
      <TabContainer as="nav">{children}</TabContainer>
    </div>
  );
}

TabBar.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string.isRequired,
};

export default TabBar;
